import React from 'react'
import style from '../scss/components/BlueBox.module.scss'

type BlueBoxPropTypes = {
    img?: string
    img_size?: {
        width: number
        height: number
    }
    title?: string
    children: any
}

const BlueBox = (props: BlueBoxPropTypes) => {
    return (
        <div className={style.Box}>
            {props.img && <div className={style.Image}>
                <img src={props.img} width={props?.img_size?.width ?? 150}
                     height={props?.img_size?.height ?? 150} alt={''}/>
            </div>}
            {props.title && <h2>{props.title}</h2>}
            <p>{props.children}</p>
        </div>
    )
}

export default BlueBox
